import { useUser } from 'hooks';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'routing/AppRoutes';
import { UpdateSnackBar } from 'ui';

export const App = () => {
  const { setUser } = useUser();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setUser(JSON.parse(user));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AppRoutes />
      <UpdateSnackBar />
    </>
  );
};
